import { useAvailablePersonas } from '@festina-life/authentication'
import { useEffect } from 'react'

import { usePersona } from '../../hooks/usePersona'

export const SetPersona = () => {
  const [persona, setPersona] = usePersona()
  const availablePersonas = useAvailablePersonas()

  useEffect(() => {
    if (!persona && availablePersonas) {
      setPersona(availablePersonas[0])
    }
  }, [availablePersonas, persona, setPersona])

  return null
}
